import React from 'react';
import { SkeletonComponent } from '@design-system';

export const FavoriteOrdersSkeleton: React.FC = () => {
    return (
        <div style={{ marginTop: '85px' }}>
            {[...Array(6)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '109px',
                        width: '100%',
                        margin: '-8px auto',
                        display: 'block'
                    }}
                />
            ))}
        </div>
    );
};
